module.exports = __webpack_public_path__ + "img/bg_button_gradation.b1febe2.svg";